export default class User {
    constructor() {
        this.id;
        this.identificationNumber;
        this.name;
        this.surname;
        this.phone;
        this.email;
        this.identityTypeId;
        this.idDocumentFileId;
        this.createdAt;
        this.modifiedAt;
        this.country;
        this.addressLine1;
        this.addressLine2;
        this.addressLine3;
        this.city;
        this.province;
        this.postalCode;
        this.idDocumentAvailable;
        this.dateOfBirth;
        this.idDocPlaceOfIssue;
        this.idDocExpirationDate;
        this.verifiedRsaIdId;
        this.deceased;
        this.title;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.identificationNumber = setEntity.identificationNumber;
        this.name = setEntity.name;
        this.surname = setEntity.surname;
        this.phone = setEntity.phone;
        this.email = setEntity.email;
        this.identityTypeId = setEntity.identityTypeId;
        this.idDocumentFileId = setEntity.idDocumentFileId;
        this.createdAt = setEntity.createdAt;
        this.modifiedAt = setEntity.modifiedAt;
        this.country = setEntity.country;
        this.addressLine1 = setEntity.addressLine1;
        this.addressLine2 = setEntity.addressLine2;
        this.addressLine3 = setEntity.addressLine3;
        this.city = setEntity.city;
        this.province = setEntity.province;
        this.postalCode = setEntity.postalCode;
        this.idDocumentAvailable = setEntity.idDocumentAvailable;
        this.dateOfBirth = setEntity.dateOfBirth;
        this.idDocPlaceOfIssue = setEntity.idDocPlaceOfIssue;
        this.idDocExpirationDate = setEntity.idDocExpirationDate;
        this.verifiedRsaIdId = setEntity.verifiedRsaIdId;
        this.deceased = setEntity.deceased;
        this.title = setEntity.title;

        return this;
    }
}
